import { STORE_THEME_KEY, type EThemeMode } from '@common/types';

export const setStoredTheme = (mode: EThemeMode): void => {
  if (typeof window === 'undefined' || !window.localStorage) return;
  window.localStorage.setItem(STORE_THEME_KEY, mode);
};

export const applyThemeAttribute = (resolved: EThemeMode): void => {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.theme = resolved;
};
